var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3636 1.23195C13.3058 1.02226 13.2119 0.835692 13.0238 0.694691C12.8684 0.579256 12.6761 0.516014 12.4777 0.515116C12.2793 0.514218 12.0863 0.575715 11.9297 0.689738C11.8679 0.735944 11.809 0.785448 11.7533 0.838004C10.2061 2.285 8.65926 3.73254 7.11277 5.18063C7.06812 5.22946 7.01808 5.27373 6.96349 5.31272C6.93913 5.27177 6.9229 5.22323 6.88902 5.1912C5.3303 3.72858 3.76993 2.26683 2.20792 0.805972C1.93229 0.548076 1.61361 0.449012 1.23458 0.561284C0.679789 0.726391 0.453921 1.39309 0.802956 1.82963C0.842479 1.87936 0.885764 1.92637 0.932478 1.9703C2.73142 3.65417 4.53047 5.33748 6.32965 7.02025C6.65821 7.32735 7.07536 7.38844 7.45051 7.18172C7.54109 7.12792 7.62409 7.06369 7.69755 6.99053C9.44544 5.35774 11.193 3.7245 12.9401 2.09083C13.1339 1.90987 13.3068 1.7233 13.3636 1.46343L13.3636 1.23195Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.da2037cdcd50aa7953102e362075a936.svg";
export { ForwardRef as ReactComponent };